import { ADD_TO_CART, REMOVE_FROM_CART, CLEAR_CART } from '../actions/CartActions';

const initialState = {};

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART:
            return {
                ...state,
                ...action.payload,
            };

        case REMOVE_FROM_CART:
            const newState = { ...state };
            delete newState[action.payload.key];
            return newState;

        case CLEAR_CART:
            return initialState;

        default:
            return state;
    }
};

export default cartReducer;
